<template>
    <div v-if="state !== 'hidden'" class="listing-index-section">
        <div class="row">
            <div class="col-md-12">
                <h3 class="listing-index-section__title">
                    {{ $t("dashboard:listing_index:section") }}, {{ $t("dashboard:apartments") }}, {{ regionName }}
                </h3>
            </div>
            <div v-if="state === 'no_series'" class="col-md-12">
                <listing-index-graph :apiData="graphData.asking_index" :infoSlug="infoSlug" />
            </div>
            <div v-for="graph in visibleGraphs" :key="graph.key" :class="columnClass">
                <listing-index-graph
                    :title="$t(graph.titleKey)"
                    :subtitle="`${ $t('dashboard:apartments') }, ${regionName}`"
                    :apiData="graphResponse(graph)"
                    :seriesName="graph.previousMethod ? $t('dashboard:previous_method') : regionName"
                    :kind="graph.kind"
                    :displayUnit="graph.unitKey ? $t(graph.unitKey) : graph.unit"
                    :decimalPlaces="graph.decimals"
                    :previousMethod="Boolean(graph.previousMethod)"
                    :showGrowth="!graph.previousMethod"
                    :infoSlug="infoSlug"
                />
            </div>
        </div>
    </div>
</template>
<script>
import ListingIndexGraph from "./ListingIndexGraph.vue";
import { LISTING_GRAPHS } from "./listingIndexGraphs";

const EMPTY = { empty: true, data: [], labels: [] };

/**
 * The section "Oglaševane cene in ponudba" of AnalyticsDashboard.vue and AnalyticsDashboardRegion.vue, drawn
 * from the responses of apps/analytics/services/listing_graphs.py: the v1 listing index (shown once it is
 * activated for the region's type) and, for one year, the v0 series as "previous method (to 2023)".
 */
export default {
    name: "ListingIndexSection",
    components: { ListingIndexGraph },
    props: {
        graphData: { type: Object, required: true },  // API response keyed by graph key
        regionName: { type: String, default: "" },
        columnClass: { type: String, default: "col-md-12" },  // Bootstrap column of one graph
        infoSlug: { type: String, default: "analytics-vir-in-metodologija-amas" },
    },
    computed: {
        /** "hidden" before v1 is activated for the type, "no_series" for a region without v1, else "shown". */
        state() {
            const index = this.graphData.asking_index;
            if (!index || index.reason === "not_released")
                return "hidden";
            return index.reason === "no_series" ? "no_series" : "shown";
        },
        /**
         * The graphs to draw: the previous-method graph only while v0 has data; for a region without v1 only
         * that one (the section shows a single empty state for the others).
         */
        visibleGraphs() {
            const noSeries = this.state === "no_series";
            return LISTING_GRAPHS.filter(graph => {
                if (!graph.previousMethod)
                    return !noSeries;
                const data = this.graphData[graph.key];
                return Boolean(data && data.data && data.data.some(value => value));
            });
        },
    },
    methods: {
        /** The response of a graph; advertisement_count counts new dwellings only on v1. */
        graphResponse(graph) {
            const data = this.graphData[graph.key];
            if (!data)
                return EMPTY;
            if (graph.key === "advertisement_count" && data.basis !== "entry_dwellings")
                return EMPTY;
            return data;
        },
    },
};
</script>
<style lang="scss">
.listing-index-section .listing-index-section__title {
    margin: var(--av-space-4) 0 var(--av-space-2);
    color: var(--av-color-ink);
    font-size: var(--av-font-size-section);
    font-weight: var(--av-font-weight-medium);
}
</style>
